








import { Vue, Component } from 'vue-property-decorator';
import NewsList from './components/NewsList.vue';
import * as config from './config';
@Component({
  components: {
    NewsList,
  },
})
export default class Third extends Vue {
  options = config.OPTHINES;
  created() {
    this.$addPv(379);
  }
}
